export default __webpack_public_path__ + "static/media/ic_lif3_40.9c980c35.svg";